import common from './common';
import { spine } from 'p3';

export default class Character extends PIXI.Container {
	constructor() {
		super();
		this.view = new PIXI.spine.Spine(spine('characters'));
		this.view.skeleton.setToSetupPose();
		this.view.autoUpdate = false;
		this.view.scale.set(0.5);
		this.view.update(0);
		this.addChild(this.view);

		this._caribeanSkins = [
			'caribean_1',
			'caribean_2',
			'caribean_3',
			'caribean_4',
		];
		this._australianSkins = [
			'australian_1',
			'australian_2',
		];
		this._europeanSkins = [
			'european_1',
			'european_2',
			'european_3',
			'european_4',
		];
		this._orientalSkins = [
			'oriental_1',
			'oriental_2',
			'oriental_3',
		];

		if (!common.advisor) {
			this.setSkinByRegion();
		} else {
			this.view.skeleton.setSkin(null);
			this.view.skeleton.setSkinByName(common.advisor);
		}
	}

	setSkinByRegion() {
		let array = [];

		switch (common.selectedLevel) {
		case 'tsunami':
			array = this._orientalSkins;
			break;
		case 'earthquake':
		case 'flood':
			array = this._europeanSkins;
			break;
		case 'wilfire':
			array = this._australianSkins;
			break;
		case 'hurricane':
		default:
			array = this._caribeanSkins;
			break;
		}

		const advisor = P3.utils.selectRandom(array);

		this.view.skeleton.setSkin(null);
		this.view.skeleton.setSkinByName(advisor);
		common.advisor = advisor;
	}

	playAnimation(which) {
		if (this.view.state.hasAnimation(which)) {
			this.view.state.setAnimation(0, which, true);
		}
	}

	destroy() {
		// clean up goes here
		super.destroy();
	}

	update() {
		this.view.update(window.dt);
	}
}
